import React, {useRef, useState} from 'react';
import classnames from 'classnames';
import {Tooltip} from './Tooltip';

/**
 * Renders text that visually truncates with ellipsis and shows a hover tooltip
 * whenever the text actually overflows its container. Used throughout the
 * SymbolPicker result table.
 */
export const TruncatedText: React.FC<{
  text: string;
  className?: string;
  align?: 'left' | 'right';
}> = ({text, className, align = 'left'}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [rect, setRect] = useState<DOMRect | undefined>(undefined);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  const checkTruncation = () => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  };

  const handleMouseEnter = () => {
    if (textRef.current) {
      setRect(textRef.current.getBoundingClientRect());
      checkTruncation();
      setIsHovered(true);
    }
  };

  return (
    <>
      <span
        ref={textRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => {
          setIsHovered(false);
        }}
        className={classnames('sp-truncate', {'sp-truncate--right': align === 'right'}, className)}
      >
        {text}
      </span>
      {isHovered && isTruncated && rect && <Tooltip text={text} targetRect={rect} width={140} />}
    </>
  );
};
